class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {

       var maxaval = $("#Filter-Price-LTE, #Mobile-Filter-Price-LTE").val();
      console.log("maxaval", maxaval);
    if($(".custom_pul input[type='radio']").is(':checked')){
        console.log('check found');
         var minval = $( ".custom_pul input[type='radio']:checked" ).attr("min");
        var maxval = $( ".custom_pul input[type='radio']:checked" ).attr("max");
      console.log("test1",minval, maxval);
        $("#Filter-Price-LTE, #Mobile-Filter-Price-LTE").attr("min", minval);
        $("#Filter-Price-LTE, #Mobile-Filter-Price-LTE").val(maxval);
        $("#Filter-Price-GTE, #Mobile-Filter-Price-GTE").attr("max", maxval);
        $("#Filter-Price-GTE, #Mobile-Filter-Price-GTE").val(minval);
      }else{
        console.log('check not found');
        
        $(".custom_pul input[type='radio']").each(function( i ){
         var avalvar1 = $(this).attr("max");
         var avalvar = Math.round(avalvar1);
          console.log("test", maxaval, "avalvar", avalvar);
          if ( maxaval == avalvar ) {
            console.log(this);
                $(this).attr('checked',true);             
            
          }
        });
      } 
      
      
      this.onSubmitHandler(event);
      infinite_scroll();

if($(".custom_pul input[type='radio']").is(':checked')){
      setTimeout(function() {
        console.log('check found uper', $(".custom_pul input[type='radio']").is(':checked'), $(".custom_pul input[type='radio']:checked").val());
        var preselect = $(".custom_pul input[type='radio']:checked").val();
        $(".custom_pul input[type='radio']").click(function( i ){
          var curselect = $(this).val();
          if(curselect == preselect){
            console.log("preselect");
             $(".pills_close_btn a span.price_pill").trigger( "click" );
          }
        });

      }, 1000);
  
      }
       else{
        // console.log('check not found');
        
        $(".custom_pul input[type='radio']").each(function( i ){
         var avalvar1 = $(this).attr("max");
          var avalvar = Math.round(avalvar1);
          // console.log("test", maxaval, "avalvar", avalvar);
          if ( maxaval == avalvar ) {
                $(this).attr('checked',true);
               // console.log(this);
          }
        });
        
      } 
      
      
    }, 900);


    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    // console.log("hi nik");
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading'); 
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
    var behaviourSlider = document.getElementById('noUi-target');
    $('.noUi-base').remove();
    delete behaviourSlider.noUiSlider;
    
    var behaviourSlider1 = document.getElementById('noUi-target');
    var test = $('.test_max_range').val();
    test = test / 100;
      
    noUiSlider.create(behaviourSlider1, {
        start: [0, test],
        step: 1,
        connect: true,
         tooltips: true,
        range: {
            'min': 0,
            'max': test
        }
    })
    
    behaviourSlider1.noUiSlider.updateOptions({
            start: [0, test],
            range: {
                'min': 0,
                'max': test
            }
        });
    
    if($('.active-facets facet-remove').hasClass('price_remove')){
    
      var cur_min = $('.active-facets facet-remove.price_remove').attr('min');    
       cur_min = cur_min / 100;
      var cur_max = $('.active-facets facet-remove.price_remove').attr('max');    
      cur_max = cur_max / 100;
      
        behaviourSlider1.noUiSlider.updateOptions({
            start: [cur_min, cur_max]
            // range: {
            //     'min': cur_min,
            //     'max': cur_max
            // }
        });
    }
$('.noUi-handle-lower .noUi-touch-area, .noUi-connects, .noUi-tooltip').mouseup(function(e){
    var cur_val = $('.noUi-handle-lower').attr('aria-valuenow');
    
    $('input[name="filter.v.price.gte"]').val(cur_val);
      $('input[name="filter.v.price.lte"]').attr("min", cur_val);
    $('input[name="filter.v.option.price"]').click();
    
}); 

  $('.noUi-handle-upper .noUi-touch-area, .noUi-connects, .noUi-tooltip').mouseup(function(e){
    var cur_val = $('.noUi-handle-upper').attr('aria-valuenow');
    
    $('input[name="filter.v.price.lte"]').val(cur_val);
    $('input[name="filter.v.price.gte"]').attr("max", cur_val);
    $('input[name="filter.v.option.price"]').click();
    
}); 
    

  }

  
  
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {

    if($(".custom_pul input[type='radio']").is(':checked')){
        
       $(".custom_pul input[type='radio']").each(function( i ){
         if ($(this).is(':checked')){
           var removecnt = $(this).attr("value"); 
            var removecnt = removecnt.replace(/\s/g, '+');
            var remvo = '&filter.v.option.price='+removecnt
            console.log("remvo", remvo);
           searchParams.replace('&filter.v.option.price=','');
            var searchParams1 = searchParams.replace('&filter.v.option.price=','');
            console.log("searchParams", searchParams, "searchParams1", searchParams1);
           
         }
            
       });
      }
    searchParams.replace('&filter.v.option.price=','');
    FacetFiltersForm.renderPage(searchParams, event);
    
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    $( ".custom_pul input[type='radio']:checked" ).change(function() {
          // console.log("price change");
        var minval = $(this).attr("min");
        var maxval = $(this).attr("max");
      // console.log(minval, maxval);
        $("#Filter-Price-LTE").attr("min", minval);
        $("#Filter-Price-GTE").attr("max", maxval);
      });
    var minval = $( ".custom_pul input[type='radio']:checked" ).attr("min");
    var maxval = $( ".custom_pul input[type='radio']:checked" ).attr("max");
    
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    infinite_scroll();
    
  }
}

customElements.define('facet-remove', FacetRemove);

function infinite_scroll() {

  
  
  setTimeout(function () {
    var endlessScroll = new Ajaxinate({
      container: ".infinite-Loop",
      pagination: "#infinite-Pagination",
      loadingText:
        '<center><img src="https://cdn.shopify.com/s/files/1/0731/0632/5812/t/1/assets/loading.webp"></center>',
    });

    var maxaval = $("#Filter-Price-LTE, #Mobile-Filter-Price-LTE").val();
      // console.log("infinite maxaval", maxaval);
    if($(".custom_pul input[type='radio']").is(':checked')){
      setTimeout(function() {
        console.log('check found in infinte', $(".custom_pul input[type='radio']").is(':checked'), $(".custom_pul input[type='radio']:checked").val());
        var preselect = $(".custom_pul input[type='radio']:checked").val();
        $(".custom_pul input[type='radio']").click(function( i ){
          var curselect = $(this).val();
          if(curselect == preselect){
            console.log("preselect");
             $(".pills_close_btn a span.price_pill").trigger( "click" );
          }
        });

      }, 1000);
  
      }
      else{
        // console.log('check not found');
        
        $(".custom_pul input[type='radio']").each(function( i ){
         var avalvar1 = $(this).attr("max");
          var avalvar = Math.round(avalvar1);
          // console.log("test", maxaval, "avalvar", avalvar);
          if ( maxaval == avalvar ) {
                $(this).attr('checked',true);
               // console.log(this);
          }
        });
        
      }



    $('.noUi-handle-lower .noUi-touch-area, .noUi-connects').mouseup(function(e){
    var cur_val = $('.noUi-handle-lower').attr('aria-valuenow');
    
    $('input[name="filter.v.price.gte"]').val(cur_val);
      $('input[name="filter.v.price.lte"]').attr("min", cur_val);
    $('input[name="filter.v.option.price"]').click();
      }); 
      
        $('.noUi-handle-upper .noUi-touch-area, .noUi-connects').mouseup(function(e){
          var cur_val = $('.noUi-handle-upper').attr('aria-valuenow');
          
          $('input[name="filter.v.price.lte"]').val(cur_val);
          $('input[name="filter.v.price.gte"]').attr("max", cur_val);
          $('input[name="filter.v.option.price"]').click();
      }); 
          
  }, 900);


  
  
}
